import axios from 'axios';

import { TestType, TestTypeCreate, TestTypeUpdate } from '@qality/common-model';

import StorageOfUniqueServices from './StorageOfUniqueServices';

export default {
  async getTestTypes(): Promise<TestType[]> {
    if (!StorageOfUniqueServices.get('LicenseService').isAdvanced) {
      return [];
    }
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants').URL_TEST_TYPES
    );

    const response = await axios.get(url);

    return response.data;
  },

  async deleteTestType(
    id: TestType['id'],
    replaceId: TestType['id']
  ): Promise<void> {
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants').URL_TEST_TYPES +
        `/${id}`,
      `alternativeTestTypeId=${replaceId}`
    );

    return await axios.delete(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  async createTestType(testTypeData: TestTypeCreate): Promise<TestType> {
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants').URL_TEST_TYPES
    );
    const { data: newTestType } = await axios.post(url, testTypeData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return newTestType;
  },

  async editTestType(
    testTypeData: TestTypeUpdate,
    testTypeId: TestType['id']
  ): Promise<TestType> {
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants').URL_TEST_TYPES +
        `/${testTypeId}`
    );
    const body = {
      fields: {
        ...testTypeData,
      },
    };
    const { data: editedTestType } = await axios.patch(url, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return editedTestType;
  },

  mapTestTypeToReqPayload(testType): TestTypeCreate {
    return {
      name: testType.name.trim(),
      description: testType.description,
      colorName: testType.color.label.toUpperCase(),
      iconName: testType.icon.label.toUpperCase(),
    };
  },
};
